export default __webpack_public_path__ + "media/images/icons_fc/ruby-650a626656dd30eb0179cd963648eb2f.png";